export const mConst = {
  //对象状态(0禁用1启用)
  objectStateDisable: 0,
  objectStateEnable: 1,

  //自定义字段状态(0禁用1启用)
  fieldStateDisable: '0',
  fieldStateEnable: '1',

  //返回code(0有效)
  returnCodeValid: 0,
  returnCodeExists: 999,

  //传参标题(add新增/update修改)
  titleAdd: 'add',
  titleUpdate: 'update',

  //校验规则状态(0禁用1启用)
  ruleStateDisable: '0',
  ruleStateEnable: '1',

  //校验规则弹窗标题
  addRuleModalTitle: '新增校验规则',
  updateRuleModalTitle: '编辑校验规则',

  //查重规则弹窗标题
  addRepeatModalTitle: '新增查重规则',
  updateRepeatModalTitle: '编辑查重规则',

  //校验规则类型(1查重规则，2校验规则)
  roleTypeValidate: '2',
  roleTypeRepeat: '1',

  //按钮弹窗标题
  addBtnModalTitle: '新增按钮',
  updateBtnModalTitle: '编辑按钮',
  //首页配置客户资料组件视图下拉选_假数据
  viewListFalseData: [{ viewName: '我的客户' }, { viewName: '所有客户' }],
  //首页配置客户资料组件列头_假数据
  columnsFalseData: [
    {
      title: '客户姓名',
      key: 'cust_name'
    },
    {
      title: '手机号',
      key: 'mobile_nbr'
    },
    {
      title: '客户类型',
      key: 'cust_type'
    }
  ],
  columnsFalseDataTab: [
    {
      title: '操作类型',
      key: 'cust_type'
    },
    {
      title: '操作人',
      key: 'cust_name'
    },
    {
      title: '联系电话',
      key: 'mobile_nbr'
    }
  ],
  //元数据常量定义-模板类型
  templeteTypeDetail: '0', //详情
  templeteTypeTable: '1', //列表
  templeteTypeSearch: '2', //检索
  //元数据常量定义-字段类型
  fieldTypeText: '0', //单行文本类型
  fieldTypeTextarea: '1', //多行文本框类型
  fieldTypeBoolean: '2', //布尔类型
  fieldTypeSelect: '3', //单选类型
  fieldTypeCheck: '4', //复选类型
  fieldTypeInt: '5', //整数类型
  fieldTypeDouble: '6', //实数类型
  fieldTypeRate: '7', //百分比类型
  fieldTypePhone: '8', //电话类型
  fieldTypeAutonum: '9', //自动编号类型
  fieldTypeDate: '10', //日期类型 (年月日)
  fieldTypeDatetime: '11', //日期时间类型(年月日时分秒)
  fieldTypeMail: '12', //邮箱类型
  fieldTypeWebsite: '13', //网页地址（链接）类型
  fieldTypeArea: '14', //省市区类型
  fieldTypePhoto: '15', //图片类型
  fieldTypeEnclosure: '16', //附件类型
  fieldTypeObject: '17', //关联对象
  fieldTypeObjectParam: '18', //引用字段
  fieldTypeMainChild: '19', //主子明细字段
  fieldTypeRule: '20', //计算规则
  fieldTypePosition: '21', //定位类型
  //自定义字段所属属性
  itsPropertiesMain: '0', //0.主属性字段;
  itsPropertiesObject: '1', // 1.自定义字段;
  itsPropertiesBasic: '2', // 2.系统基本字段;
  itsPropertiesDepend: '3', // 3.字段依赖性;
  itsPropertiesSystem: '4', // 4.预设字段;
  //客户列表常量
  custom: {
    //可用状态
    state: {
      enable: '0',
      disEnable: '1'
    },
    sex: {
      male: '男',
      female: '女'
    },
    version: '1.0',
    type: {
      insertId: '@id',
      selectType: 'select',
      insertType: 'insert',
      updateType: 'update',
      deleteType: 'delete',
      selectWhereOf: 'is_delete=0'
    },
    objectName: 'sccm_cust_info', //主对象A 客户资料
    customName: 'sccm_cust_info', //主对象A 客户资料
    checkedViewId: 0,
    checkedViewName: '请选择',
    pageTotal: 0,
    pageNum: 1,
    pageSize: 10,
    rightTitleAdd: '客户创建',
    rightTitleUpdate: '客户修改',
    metaMessage: '客户',
    trueNum: '1',
    falseNum: '0',
    trueOption: '是',
    falseOption: '否',
    IntegerM: 1, //整数类型 最小值
    IntegerMax: 10000, //最大值
    step: '1', //增长值
    precision: '5', //小数点位数
    itsProperties: '0,1,4', //查主属性+自定义属性+预设属性
    allProperties: '0,1,2,4', //查主属性+自定义属性+系统属性+预设属性
    mainProperties: '4', //查预设属性
    fieldState: '1', //默认有效自定义字段
    allParams: 'allParams', //查询所有字段
    viewParams: 'viewParams', //查询视图字段
    listlayoutType: '1', //列表布局类型
    detailslayoutType: '0', //详情布局类型
    isDelete: '0', //动态sql插入默认值
    //businessKey:'sccm',//动态sql插入客户资料业务主键
    businessKey: '@id', //动态sql插入客户资料业务主键
    buttonShow: '0', //按钮展示
    buttonClick: '1', //按钮点击
    buttonHide: '2', //按钮隐藏
    objectState: '1' //查询启动状态
  },
  //查询接触记录常量
  contact: {
    contactPageNum: '1',
    contactPageSize: '10',
    includeMain: '1',
    noIncludeMain: '0',
    contactType: '1',
    ifConnected: '1'
  },
  workOrder: {
    state: {
      WORK_ORDER_SAVE: '1', //暂存
      WORK_ORDER_APPROVE: '2', //受理中
      WORK_ORDER_RETURN: '3', //退回
      WORK_ORDER_END: '4', //已完结
      WORK_ORDER_DELAY_APPROVE: '5', //延期受理中
      WORK_ORDER_DELAY_NO_AGREE: '6', //延期未同意
      WORK_ORDER_DELAY_AGREE: '7', //延期已同意
      WORK_ORDER_TRANSFERING: '8', //转派处理
      WORK_ORDER_RETRANSFER: '9', //重新转派
      WORK_ORDER_TRANSAPPROVE: '10', //转派审批通过
      WORK_ORDER_TRANSRETURN: '11', //转派审批退回
      WORK_ORDER_SIGN: '12', //转派已签收
      WORK_ORDER_DELAY_AGREE_NAME: '通过',
      WORK_ORDER_DELAY_NO_AGREE_NAME: '不通过',
      WORK_ORDER_DELAY_FLOW_NAME: 'work_delay'
    },
    WORK_ORDER_HAND_CLAP_ID: '9999',
    WORK_TRAN: '转派',
    index: {
      WORK_ORDER_POOL: '4', //工单池
      WORK_ORDER_DELAY: '5' //延期代办
    },
    WORK_FROM_JC: 'WORK_FROM_JC', //接续审批详情
    WORK_FROM_WB: 'WORK_FROM_WB', //外拨调用
    WORK_FROM_SSP: 'WORK_FROM_SSP', //随手拍审批详情
    WORK_GC_HISDETAIL: 'HISDETAIL', //审批详情
    WORK_GC_TABLEDETAIL: 'TABLEDETAIL', //列表详情
    IS_SYSTEMY: '1', //系统工单类型
    IS_SYSTEM: '0', //非系统工单类型
    ITS_PROPERTIES: '1', //字段 所属属性（0.主属性字段;1.自定义字段;2.系统基本字段;3.字段依赖性）
    FIELD_STATE: '1', // 字段 状态（0.禁用;1.启用）
    OBJECT_STATE: '1' //自定义对象 状态（0.禁用;1.启用）
  },
  // 工单类型状态
  businessType: {
    state: {
      enable: '1', //启用
      disEnable: '0', //关闭
      loseEfficacy: '2', //失效
      notInState: '4,1' //不再这些状态的工单
    },
    madateTpye: 'scwf', //对象 应用类型
    objectState: '1' //对象 状态
  },
  //后台返回执行结果返回 Code
  returnResultCode: {
    successCode: 0
  },
  //校验规则运算符
  validOperator: [
    { value: ' + ', label: '加' },
    { value: ' - ', label: '减' },
    { value: ' * ', label: '乘' },
    { value: ' / ', label: '除' },
    { value: ' < ', label: '小于' },
    { value: ' > ', label: '大于' },
    { value: ' == ', label: '等于' },
    { value: ' != ', label: '不等于' },
    // {value: " && ",label: "且"},
    { value: ' >= ', label: '大于等于' },
    { value: ' <= ', label: '小于等于' },
    // {value: " || ",label: "或"},
    { value: '.length() == 11', label: '手机号合法性验证' }
  ],

  //定时任务启用状态
  jobEnable: '1',
  jobDisEnable: '0',

  //请求方式
  jobPost: 'POST',
  jobGet: 'GET',
  file: {
    maxSize: 5120,
    fileType: "['jpg','jpeg','png','xls','xlsx','doc','docx','ppt','txt']"
  },
  //校验是否通过0通过1未通过
  validTrue: '0',
  validFalse: '1',

  setParams: function(thisObj, fieldName, data) {
    if (fieldName) {
      thisObj.$set(thisObj.queryParmaeters, fieldName, data)
    }
  },
  executeSearch: function(thisObj, fieldName, data) {
    fieldName && thisObj.$set(thisObj.queryParmaeters, fieldName, data)
    if (thisObj.fromPageType && thisObj.fromPageType === 'WORK_ORDER') {
      thisObj.executeSearchWorkOrderImpl(thisObj.queryParmaeters)
    } else {
      if (thisObj.pageSize) {
        thisObj.$set(thisObj.queryParmaeters, 'pageSize', thisObj.pageSize)
        thisObj.$set(thisObj.queryParmaeters, 'pageNum', thisObj.pageNum)
      }
      thisObj.$http
        .post(thisObj.queryUrl, thisObj.queryParmaeters)
        .then(response => {
          if (thisObj.returnData && response.data.returnCode === 0) {
            thisObj.returnData = response.data.beans
          }

          thisObj.callbackSearchReturnData &&
            thisObj.callbackSearchReturnData(response.data)
        })
    }
  },
  setColumnsSearch: function(thisObj, columsObj) {
    columsObj.forEach(item => {
      mConst.setColumnSearch(thisObj, item)
    })
  },
  setColumnSearch: function(thisObj, queryColumns) {
    if (!queryColumns) return
    if (queryColumns.denySearchColumn) return

    if (
      queryColumns.fieldType == mConst.fieldTypeBoolean ||
      queryColumns.fieldType == mConst.fieldTypeSelect
    ) {
      var options = []
      var tmpItems = queryColumns.fieldValue.split('|')
      if (tmpItems) {
        tmpItems.forEach(item => {
          if (item) {
            var tmpVals = item.split(':')
            options.push({ label: tmpVals[1], value: tmpVals[0] })
          }
        })

        thisObj.$set(queryColumns, 'filters', options)
        thisObj.$set(queryColumns, 'filterMultiple', false)
        thisObj.$set(queryColumns, 'filterRemote', function(data) {
          //执行远程查询
          thisObj.pageNum && (thisObj.pageNum = 1)
          var fieldName = queryColumns.key
          mConst.executeSearch(thisObj, fieldName, data)
        })
      }
    } else {
      thisObj.$set(queryColumns, 'renderHeader', h => {
        if (
          queryColumns.fieldType == mConst.fieldTypeDate ||
          queryColumns.fieldType == mConst.fieldTypeDatetime
        ) {
          //日期类型
          return h('span', {}, [
            h('span', queryColumns.title),
            h('Poptip', { props: { placement: 'bottom', transfer: true } }, [
              h('Icon', { props: { type: 'md-calendar' } }, queryColumns.title),
              h('span', { class: 'api', slot: 'content' }, [
                h('DatePicker', {
                  props: {
                    type: 'daterange',
                    format: 'yyyy-MM-dd',
                    size: 'small',
                    placement: 'bottom-end',
                    confirm: 'true'
                  },
                  on: {
                    'on-change': function(data) {
                      // thisObj.pageNum && (thisObj.pageNum = 1);
                      var fieldName = queryColumns.key
                      if (data[0] !== '') {
                        data = 'DATE:' + data
                      } else {
                        data = ''
                      }
                      mConst.setParams(thisObj, fieldName, data)
                    },
                    ['on-ok']() {
                      var fieldName = queryColumns.key
                      mConst.executeSearch(
                        thisObj,
                        fieldName,
                        thisObj.queryParmaeters[fieldName]
                      )
                    },
                    ['on-clear']() {
                      var fieldName = queryColumns.key
                      mConst.executeSearch(
                        thisObj,
                        fieldName,
                        thisObj.queryParmaeters[fieldName]
                      )
                    }
                  }
                })
              ])
            ])
          ])
        } else {
          //文本型
          return h('span', {}, [
            h('span', queryColumns.title),
            h('Poptip', { props: { placement: 'bottom', transfer: true } }, [
              h(
                'Icon',
                { props: { type: 'ios-search-outline' } },
                queryColumns.title
              ),
              h('div', { class: 'api', slot: 'content' }, [
                h(
                  'Row',
                  {
                    props: {
                      gutter: '0'
                    }
                  },
                  [
                    h(
                      'Col',
                      {
                        props: {
                          span: '12'
                        },
                        style: {
                          marginTop: '2px'
                        }
                      },
                      [
                        h('Icon', {
                          props: {
                            type: 'ios-funnel'
                          },
                          style: {
                            marginRight: '5px'
                          }
                        }),
                        h('span', '筛选')
                      ]
                    ),
                    h(
                      'Col',
                      {
                        props: {
                          span: '12'
                        },
                        style: {
                          textAlign: 'right'
                        }
                      },
                      [
                        h(
                          'Button',
                          {
                            props: {
                              type: 'text',
                              size: 'small'
                            },
                            style: {
                              background: 'none',
                              boxShadow: 'none',
                              marginBottom: '3px',
                              color: '#1565c0'
                            },
                            on: {
                              click: () => {
                                thisObj.pageNum && (thisObj.pageNum = 1)
                                let fieldName = queryColumns.key
                                document.querySelector(
                                  "div[ref='" + fieldName + "']"
                                ).children[2].value = ''
                                mConst.executeSearch(thisObj, fieldName, '')
                              }
                            }
                          },
                          '重置'
                        )
                      ]
                    )
                  ]
                ),
                h('Input', {
                  attrs: { ref: queryColumns.key },
                  props: { search: true, placeholder: '' },
                  on: {
                    'on-search': function(data) {
                      thisObj.pageNum && (thisObj.pageNum = 1)
                      var fieldName = queryColumns.key
                      mConst.executeSearch(thisObj, fieldName, data)
                    }
                  }
                })
              ])
            ])
          ])
        }
      })
    }
  },

  //解决数据全排序查询
  sortDynamicSearch: function(thisObj, key, order) {
    let bindData = JSON.parse(JSON.stringify(thisObj.selectActionData))
    thisObj.queryParmaeters = bindData
    if (key != undefined && '' != key && (order != undefined && '' != order)) {
      thisObj.queryParmaeters.Data[0].orderBy = key + ' ' + order
    }
    var arrKeys = Object.keys(thisObj.searchWhereOf)
    for (var i = 0; i < arrKeys.length; i++) {
      //日期类型 日期时间类型
      if (
        thisObj.searchWhereOf[arrKeys[i] + '_type'] ==
          thisObj.fieldTypeDatetime ||
        thisObj.searchWhereOf[arrKeys[i] + '_type'] == thisObj.fieldTypeDate
      ) {
        thisObj.queryParmaeters.Data[0].whereOf =
          thisObj.queryParmaeters.Data[0].whereOf +
          ' and ' +
          arrKeys[i] +
          " between '" +
          thisObj.searchWhereOf[arrKeys[i]][0] +
          "' and '" +
          thisObj.searchWhereOf[arrKeys[i]][1] +
          "'"
      }
      //文本类型、多行文本
      if (
        thisObj.searchWhereOf[arrKeys[i] + '_type'] == thisObj.fieldTypeText ||
        thisObj.searchWhereOf[arrKeys[i] + '_type'] == thisObj.fieldTypeTextarea
      ) {
        thisObj.queryParmaeters.Data[0].whereOf =
          thisObj.queryParmaeters.Data[0].whereOf +
          ' and ' +
          arrKeys[i] +
          " like '%" +
          thisObj.searchWhereOf[arrKeys[i]].trim() +
          "%'"
      }
      //单选
      if (
        thisObj.searchWhereOf[arrKeys[i] + '_type'] == thisObj.fieldTypeSelect
      ) {
        if (
          thisObj.searchWhereOf[arrKeys[i]] != null &&
          thisObj.searchWhereOf[arrKeys[i]] != ''
        ) {
          thisObj.queryParmaeters.Data[0].whereOf =
            thisObj.queryParmaeters.Data[0].whereOf +
            ' and ' +
            arrKeys[i] +
            " = '" +
            thisObj.searchWhereOf[arrKeys[i]] +
            "'"
        } else {
          thisObj.queryParmaeters.Data[0].whereOf =
            thisObj.queryParmaeters.Data[0].whereOf +
            ' and ' +
            arrKeys[i] +
            " like '%" +
            thisObj.searchWhereOf[arrKeys[i]] +
            "%'"
        }
      }
      //电话类型
      if (
        thisObj.searchWhereOf[arrKeys[i] + '_type'] == thisObj.fieldTypePhone
      ) {
        thisObj.queryParmaeters.Data[0].whereOf =
          thisObj.queryParmaeters.Data[0].whereOf +
          ' and ' +
          arrKeys[i] +
          " like '%" +
          thisObj.searchWhereOf[arrKeys[i]] +
          "%'"
      }
      //整数/实数类型
      if (
        thisObj.searchWhereOf[arrKeys[i] + '_type'] == thisObj.fieldTypeInt ||
        thisObj.searchWhereOf[arrKeys[i] + '_type'] == thisObj.fieldTypeDouble
      ) {
        thisObj.queryParmaeters.Data[0].whereOf =
          thisObj.queryParmaeters.Data[0].whereOf +
          ' and ' +
          arrKeys[i] +
          " like '%" +
          thisObj.searchWhereOf[arrKeys[i]] +
          "%'"
      }
      //复选类型
      if (
        thisObj.searchWhereOf[arrKeys[i] + '_type'] == thisObj.fieldTypeCheck
      ) {
        thisObj.queryParmaeters.Data[0].whereOf =
          thisObj.queryParmaeters.Data[0].whereOf +
          ' and ' +
          arrKeys[i] +
          " like '%" +
          thisObj.searchWhereOf[arrKeys[i]] +
          "%'"
      }
      //百分比类型
      if (
        thisObj.searchWhereOf[arrKeys[i] + '_type'] == thisObj.fieldTypeRate
      ) {
        thisObj.queryParmaeters.Data[0].whereOf =
          thisObj.queryParmaeters.Data[0].whereOf +
          ' and ' +
          arrKeys[i] +
          " like '%" +
          thisObj.searchWhereOf[arrKeys[i]] +
          "%'"
      }
    }
    mConst.executeDynamicSearch(thisObj)
  },

  //支持动态sql
  setDynamicColumns: function(thisObj, columsObj) {
    columsObj.forEach(item => {
      mConst.setDynamicSearch(thisObj, item)
    })
  },
  setDynamicSearch: function(thisObj, queryColumns) {
    if (!queryColumns) return
    if (queryColumns.key === 'is_delete') return
    if (!queryColumns.fieldType) return
    if (queryColumns.fieldType == mConst.fieldTypeBoolean) {
      //布尔
      thisObj.$set(queryColumns, 'renderHeader', h => {
        return h(
          'tooltip',
          {
            props: {
              placement: 'bottom',
              transfer: true,
              content: queryColumns.title
            },
            style: {
              position: 'relative',
              top: '4px'
            }
          },
          [
            h(
              'span',
              {
                style: {
                  maxWidth: '80px',
                  display: 'inline-block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer'
                }
              },
              queryColumns.title
            )
          ]
        )
      })
      let options = []
      options.push({ label: '是', value: 1 })
      options.push({ label: '否', value: 0 })
      thisObj.$set(queryColumns, 'filters', options)
      thisObj.$set(queryColumns, 'filterMultiple', false)
      thisObj.$set(queryColumns, 'filterRemote', function(data) {
        //执行远程查询
        mConst.searchDynamicParams(thisObj, queryColumns, data)
      })
    }
    if (queryColumns.fieldType == mConst.fieldTypeSelect) {
      //单选
      thisObj.$set(queryColumns, 'renderHeader', h => {
        return h(
          'tooltip',
          {
            props: {
              placement: 'bottom',
              transfer: true,
              content: queryColumns.title
            },
            style: {
              position: 'relative',
              top: '4px'
            }
          },
          [
            h(
              'span',
              {
                style: {
                  maxWidth: '80px',
                  display: 'inline-block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer'
                }
              },
              queryColumns.title
            )
          ]
        )
      })

      let options = []
      let tmpItems = queryColumns.fieldValue.split('|')
      if (tmpItems) {
        tmpItems.forEach(item => {
          if (item) {
            var tmpVals = item.split(':')
            options.push({ label: tmpVals[1], value: tmpVals[0] })
          }
        })
        thisObj.$set(queryColumns, 'filters', options)
        thisObj.$set(queryColumns, 'filterMultiple', false)
        if (queryColumns.fieldType == mConst.fieldTypeCheck) {
          thisObj.$set(queryColumns, 'filterMultiple', true) //复选
        }
        thisObj.$set(queryColumns, 'filterRemote', function(data) {
          //执行远程查询
          data = data.sort(thisObj.sortOptions)
          mConst.searchDynamicParams(thisObj, queryColumns, data.join(','))
        })
      }
    }
    if (queryColumns.fieldType == mConst.fieldTypeCheck) {
      //复选
      thisObj.$set(queryColumns, 'renderHeader', h => {
        return h(
          'tooltip',
          {
            props: {
              placement: 'bottom',
              transfer: true,
              content: queryColumns.title
            },
            style: {
              position: 'relative',
              top: '4px'
            }
          },
          [
            h(
              'span',
              {
                style: {
                  maxWidth: '80px',
                  display: 'inline-block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer'
                }
              },
              queryColumns.title
            )
          ]
        )
      })

      let options = []
      let tmpItems = queryColumns.fieldValue.split('|')
      if (tmpItems) {
        tmpItems.forEach(item => {
          if (item) {
            var tmpVals = item.split(':')
            options.push({ label: tmpVals[1], value: tmpVals[0] })
          }
        })
        thisObj.$set(queryColumns, 'filters', options)
        thisObj.$set(queryColumns, 'filterMultiple', true)
        thisObj.$set(queryColumns, 'filterRemote', function(data) {
          //执行远程查询
          data = data.sort(thisObj.sortOptions)
          mConst.searchDynamicParams(thisObj, queryColumns, data.join(','))
        })
      }
    }
    if (queryColumns.fieldType == mConst.fieldTypeAutonum) {
      //自动编号
      thisObj.$set(queryColumns, 'renderHeader', h => {
        return h(
          'tooltip',
          {
            props: {
              placement: 'bottom',
              transfer: true,
              content: queryColumns.title
            },
            style: {
              position: 'relative',
              top: '4px'
            }
          },
          [
            h(
              'span',
              {
                style: {
                  maxWidth: '80px',
                  display: 'inline-block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer'
                }
              },
              queryColumns.title
            )
          ]
        )
      })
    }
    if (
      queryColumns.fieldType == mConst.fieldTypeDate &&
      queryColumns.timeType == '1'
    ) {
      thisObj.$set(queryColumns, 'renderHeader', h => {
        return h(
          'tooltip',
          {
            props: {
              placement: 'bottom',
              transfer: true,
              content: queryColumns.title
            },
            style: {
              position: 'relative',
              top: '4px'
            }
          },
          [
            h(
              'span',
              {
                style: {
                  maxWidth: '80px',
                  display: 'inline-block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer'
                }
              },
              queryColumns.title
            )
          ]
        )
      })
    }
    if (
      queryColumns.fieldType == mConst.fieldTypeDate &&
      queryColumns.timeType == '0'
    ) {
      thisObj.$set(queryColumns, 'renderHeader', h => {
        return h(
          'tooltip',
          {
            props: {
              placement: 'bottom',
              transfer: true,
              content: queryColumns.title
            },
            style: {
              position: 'relative',
              top: '4px'
            }
          },
          [
            h(
              'span',
              {
                style: {
                  maxWidth: '80px',
                  display: 'inline-block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer'
                }
              },
              queryColumns.title
            ),
            h(
              'Poptip',
              {
                props: {
                  placement: 'bottom',
                  transfer: true
                }
              },
              [
                h(
                  'Icon',
                  {
                    props: { type: 'md-calendar' },
                    style: { marginBottom: '8px' }
                  },
                  queryColumns.title
                ),
                h('span', { class: 'api', slot: 'content' }, [
                  h('DatePicker', {
                    props: {
                      type: 'daterange',
                      format: 'yyyy-MM-dd',
                      size: 'small',
                      placement: 'bottom-end'
                    },
                    on: {
                      'on-change': function(data) {
                        /* thisObj.pageOnclick = false;
                                                 thisObj.selectActionData.Data[0].whereOf = thisObj.oldActionData.Data[0].whereOf;//原始搜索条件
                                                 let selqure = queryColumns.key;*/
                        mConst.searchDynamicParams(thisObj, queryColumns, data)
                      }
                    }
                  })
                ])
              ]
            )
          ]
        )
      })
    }
    if (
      queryColumns.fieldType == mConst.fieldTypeText ||
      queryColumns.fieldType == mConst.fieldTypeInt ||
      queryColumns.fieldType == mConst.fieldTypeDouble
    ) {
      //文本 整数 实数
      thisObj.$set(queryColumns, 'renderHeader', h => {
        return h(
          'tooltip',
          {
            props: {
              placement: 'bottom',
              transfer: true,
              content: queryColumns.title
            },
            style: {
              position: 'relative',
              top: '4px'
            }
          },
          [
            h(
              'span',
              {
                style: {
                  maxWidth: '80px',
                  display: 'inline-block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer'
                }
              },
              queryColumns.title
            ),
            h(
              'Poptip',
              {
                props: {
                  placement: 'bottom',
                  transfer: 'true'
                }
              },
              [
                h(
                  'Icon',
                  {
                    props: { type: 'ios-search-outline' },
                    style: { marginBottom: '8px' }
                  },
                  queryColumns.title
                ),
                h('div', { class: 'api', slot: 'content' }, [
                  h(
                    'Row',
                    {
                      props: {
                        gutter: '0'
                      }
                    },
                    [
                      h(
                        'Col',
                        {
                          props: {
                            span: '12'
                          },
                          style: {
                            marginTop: '2px'
                          }
                        },
                        [
                          h('Icon', {
                            props: {
                              type: 'ios-funnel'
                            },
                            style: {
                              marginRight: '5px'
                            }
                          }),
                          h('span', '筛选')
                        ]
                      ),
                      h(
                        'Col',
                        {
                          props: {
                            span: '12'
                          },
                          style: {
                            textAlign: 'right'
                          }
                        },
                        [
                          h(
                            'Button',
                            {
                              props: {
                                type: 'text',
                                size: 'small'
                              },
                              style: {
                                background: 'none',
                                boxShadow: 'none',
                                marginBottom: '3px',
                                color: '#1565c0'
                              },
                              on: {
                                click: () => {
                                  let selqure = queryColumns.key
                                  document.querySelector(
                                    "div[ref='" + selqure + "']"
                                  ).children[2].value = ''
                                  mConst.searchDynamicParams(
                                    thisObj,
                                    queryColumns,
                                    ''
                                  )
                                }
                              }
                            },
                            '重置'
                          )
                        ]
                      )
                    ]
                  ),
                  h('Input', {
                    attrs: { ref: queryColumns.key },
                    props: {
                      search: true,
                      placeholder: '',
                      ref: 'restsearchi'
                    },
                    on: {
                      'on-search': function(data) {
                        /*   thisObj.pageOnclick = false;
                                                   thisObj.selectActionData.Data[0].whereOf = thisObj.oldActionData.Data[0].whereOf;//原始搜索条件
                                                 */
                        let selqure = queryColumns.key
                        if (data != '') {
                          mConst.searchDynamicParams(
                            thisObj,
                            queryColumns,
                            data
                          )
                        } else {
                          mConst.searchDynamicParams(
                            thisObj,
                            queryColumns,
                            document.querySelector("div[ref='" + selqure + "']")
                              .children[2].value
                          )
                        }
                        //mConst.searchDynamicParams(thisObj, queryColumns, document.querySelector("div[ref='" + selqure + "']").children[2].value);
                      }
                    }
                  })
                ])
              ]
            )
          ]
        )
      })
    }
  },
  //列搜索方法
  searchDynamicParams: function(thisObj, queryColumns, data) {
    //日期类型 日期时间类型
    if (
      queryColumns.fieldType == thisObj.fieldTypeDatetime ||
      queryColumns.fieldType == thisObj.fieldTypeDate
    ) {
      if (data[0].trim() == '') {
        thisObj.$delete(thisObj.searchWhereOf, queryColumns.key)
      } else {
        thisObj.$set(
          thisObj.searchWhereOf,
          queryColumns.key,
          ' and ' +
            queryColumns.key +
            " between '" +
            data[0] +
            "' and '" +
            data[1] +
            "'"
        )
      }
    } else if (queryColumns.fieldType == thisObj.fieldTypeSelect) {
      if (data != null && data != '') {
        thisObj.$set(
          thisObj.searchWhereOf,
          queryColumns.key,
          ' and ' + queryColumns.key + " = '" + data.trim() + "'"
        )
      } else {
        thisObj.$delete(thisObj.searchWhereOf, queryColumns.key)
      }
    } else {
      if (data != null && data != '') {
        if (queryColumns.key === 'create_by') {
          thisObj.$set(
            thisObj.searchWhereOf,
            queryColumns.key,
            ' and  create_by=' + data.trim()
          )
        } else if (queryColumns.key === 'business_type') {
          thisObj.$set(
            thisObj.searchWhereOf,
            queryColumns.key,
            ' and  business_type=' + data.trim()
          )
        } else {
          thisObj.$set(
            thisObj.searchWhereOf,
            queryColumns.key,
            ' and ' + queryColumns.key + " like '%" + data.trim() + "%'"
          )
        }
      } else {
        thisObj.$delete(thisObj.searchWhereOf, queryColumns.key)
      }
    }
    let whereOf = ''
    Object.keys(thisObj.searchWhereOf).forEach(key => {
      whereOf += thisObj.searchWhereOf[key]
    })

    thisObj.selectActionData.Data[0].whereOf = whereOf
    thisObj.queryParmaeters.selectActionData = thisObj.selectActionData
    thisObj.getTableData()
  }
}
